<div class="container">
  <div class="img" *ngIf="!showCreatePassword">
    <img src="/assets/step1.gif" alt="signup" />
  </div>
  <form class="form" *ngIf="!showCreatePassword">
    <p class="title">Forgot Password</p>
    <p class="message">Write your email to check if you have an account.</p>
    <label>
      <input
        [(ngModel)]="email"
        required
        name="email"
        placeholder=""
        type="email"
        class="input"
      />
      <span>Email</span>
    </label>

    <button class="submit" (click)="sendEmail()">Send</button>

    <p class="signin">
      Don't have an account?
      <a href="#" routerLink="/register" class="text login-link">Sign up now</a>
    </p>
  </form>

  <div class="img" *ngIf="showCreatePassword">
    <img src="/assets/step2.gif" alt="signup" />
  </div>
  <form class="form" *ngIf="showCreatePassword" [formGroup]="passwordForm">
    <p class="title">Reset Password</p>
    <p class="message">Create new password.</p>
    <label>
      <input
        formControlName="password"
        required
        placeholder=""
        type="password"
        class="input"
      />
      <span>New Password</span>
    </label>

    <label>
      <input
        formControlName="passwordConfirm"
        required
        placeholder=""
        type="password"
        class="input"
      />
      <span>Confirm Password</span>
    </label>

    <button class="submit" (click)="saveNewPassword()">Save</button>
  </form>
</div>
